import { current } from "@reduxjs/toolkit";
import { isAccountant, isAdmin } from "src/Common/function";
import api from "./api";
import UserService from "./user.service";

// Vendor management listing — hits the vendor:read-gated endpoint.
const getAll = (keyword, config = {}) => {
  return api.get("/api/vendor/get_all", { params: { keyword }, ...config });
};

// Vendor list for selection contexts (PO create modal, PO filter, global
// search). Hits an ungated endpoint so picking a vendor while doing another
// task does not require standalone vendor:read access.
const getAllForSelection = (keyword = "", config = {}) => {
  return api.get("/api/vendor/get_all_for_selection", { params: { keyword }, ...config });
};

//this function can be used when creating a purchase order
const getAllByBranch = (branchId) => {
  return api.get("/api/vendor/get_all_for_selection", { params: { branchId } });
};

const saveVendor = (vendor) => {
  // let currentUser = UserService.getCurrentUser();
  // let branchId = branch;
  // if (currentUser.branches.length === 1) {
  //   branchId = currentUser.branches[0].id;
  // }
  // vendor["branch"] = branchId;
  return api.post("/api/vendor/save", vendor);
};

const deleteVendor = (id) => {
  return api.post("/api/vendor/delete", { vendorId: id });
};

const updateVendor = (vendor) => {
  return api.post("/api/vendor/update", { ...vendor });
};

const VendorService = {
  getAll,
  getAllForSelection,
  getAllByBranch,
  saveVendor,
  deleteVendor,
  updateVendor,
};

export default VendorService;
